import fvSubassembly from "../fvSubassembly"
export default class fvLineObj extends fvSubassembly{
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.initPoints = JSON.parse(JSON.stringify(this.points));
        this.initArrowWidth = 5 + (this.borderWidth)*2;
		this.height = this.height ? this.height : this.borderWidth;
		this.width = this.width ? this.width : this.borderWidth;
		this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }

        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }
    init(){
        super.init();
        
        //箭头缩放
        this.arrowWidth = this.initArrowWidth* this.magnification.x;
        //根据边框对画布宽高调整
        // 根据x y 因边框、缩放改变导致绘制线重新计算
        for(var i = 0; i<this.points.length; i++){
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX ;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY ;
            this.points[i][0] = parseFloat(points0 * this.magnification.x)+this.borderWidth/2;
            this.points[i][1] = parseFloat(points1 * this.magnification.y)+this.borderWidth/2;
        }
        //初始化线条定位
        //构造线的真实开始点
        this.start = {
            x : this.cx + (parseFloat(this.points[0][0])+parseFloat(0)),
            y : this.cy + (parseFloat(this.points[0][1])+parseFloat(0))
        }

        //构造线的真实结束点
        this.end = {
            x : this.cx + (parseFloat(this.points[1][0])+parseFloat(0)),
            y : this.cy + (parseFloat(this.points[1][1])+parseFloat(0))
        }
        //计算线长度（为绘制带箭头的线时，需要缩短先长度计算提供依据）
        var xSquare = (this.end.x-this.start.x)*(this.end.x-this.start.x);
        var YSquare = (this.end.y-this.start.y)*(this.end.y-this.start.y);
        this.line_len = Math.sqrt(xSquare+YSquare);
        
    }
    
    onDraw(canvas){
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        //宽赋用于设置宽高
        // this.initPoints[0][1] = this.height;
        // this.initPoints[1][0] = this.width;
        if(this.lineType > 0){
            canvas.setLineDash(this.lineStyle(this.lineType));
        }
        this.init();
        canvas.beginPath();
        if(this.borderWidth == 0){
            canvas.lineWidth = 0.01;
        }else{
            canvas.lineWidth = this.borderWidth;
        }
        canvas.strokeStyle = this.borderColor;
        // canvas.canvas["type"]='line';
        this.executePreAnimation(canvas);
        if(this.arrow == "no"){
            //线没有箭头。按照真实点位置绘制
        //    if(parseFloat(this.borderWidth)>=3 && parseFloat(this.height)==0){
        //     var b=parseFloat(this.borderWidth)/2;
        //     canvas.moveTo(this.start.x-b,this.start.y);
        //     canvas.lineTo(this.end.x+b,this.end.y);
        //    }else if(parseFloat(this.borderWidth)>=3 && parseFloat(this.width)==0){
        //     var b=parseFloat(this.borderWidth)/2;
        //     canvas.moveTo(this.start.x,this.start.y-b);
        //     canvas.lineTo(this.end.x,this.end.y+b);
        //    }else{
            canvas.moveTo(this.start.x,this.start.y);
            canvas.lineTo(this.end.x,this.end.y);
        //    }
            canvas.stroke();
            canvas.closePath();
        }else{
            //线有箭头
            canvas.fillStyle = this.borderColor;
            //无论是单双箭头。线末尾可定有箭头存在。线绘制的终点需要缩短两个线宽的的长度。计算绘制的终点的点坐标
            var x_last,y_last;
            y_last = this.end.y-(this.borderWidth*2*(this.end.y-this.start.y)/this.line_len);
            x_last = this.end.x-(this.borderWidth*2*(this.end.x-this.start.x)/this.line_len);
            if(this.arrow == "single" || this.arrow == "singleSolid"){
                var x_start,y_start;
                y_start = this.start.y+(this.borderWidth*2*(this.end.y-this.start.y)/this.line_len);
                x_start = this.start.x+(this.borderWidth*2*(this.end.x-this.start.x)/this.line_len);
                var i=parseFloat(this.borderWidth)-2;
                var a=parseFloat(this.borderWidth)/2;
                
                if(parseFloat(this.borderWidth)>=3 && parseFloat(this.height)==0){
                    if(parseFloat(this.points[0][0])==parseFloat(this.points[0][1])){
                     canvas.moveTo(this.start.x-a,this.start.y);
                     canvas.lineTo(x_last+i,y_last);//箭头向右
                     canvas.moveTo(this.end.x,this.end.y);
                    }else{
                        canvas.moveTo(this.start.x+a,this.start.y);
                        canvas.lineTo(x_last-i,y_last);//箭头向左
                        canvas.moveTo(this.end.x,this.end.y);
                    }
                 }else if(parseFloat(this.borderWidth)>=3 && parseFloat(this.width)==0){
                     if(parseFloat(this.points[0][0])==parseFloat(this.points[0][1])){
                        canvas.moveTo(this.start.x,this.start.y-a);
                        canvas.lineTo(x_last,y_last+i);//箭头向下
                        canvas.moveTo(this.end.x,this.end.y);
                     }else{
                        canvas.moveTo(this.start.x,this.start.y+a);
                        canvas.lineTo(x_last,y_last-i);//箭头向上
                        canvas.moveTo(this.end.x,this.end.y);
                     }
                   
                 }
                //  else if(parseFloat(this.borderWidth)>=3 && parseFloat(this.width)!==0 && parseFloat(this.height)!==0){
                //      if(parseFloat(this.points[0][1])==parseFloat(this.points[1][0])){
                //         canvas.moveTo(this.start.x+i,this.start.y-i/2);
                //         canvas.lineTo(x_last-i,y_last+i/2);
                //         canvas.moveTo(this.end.x,this.end.y);
                //      }else if(parseFloat(this.points[0][0])==parseFloat(this.points[1][1])){
                //         canvas.moveTo(this.start.x-i,this.start.y+i/2);
                //         canvas.lineTo(x_last+i,y_last-i/2);
                //         canvas.moveTo(this.end.x,this.end.y);
                //      }else if(parseFloat(this.points[0][0])==parseFloat(this.points[0][1])){
                //         canvas.moveTo(this.start.x-a,this.start.y-a);
                //         canvas.lineTo(x_last+a,y_last+a);
                //         canvas.moveTo(this.end.x,this.end.y);
                //     }else if(parseFloat(this.points[1][0])==parseFloat(this.points[1][1])){
                //         canvas.moveTo(this.start.x+i/2,this.start.y+i);
                //         canvas.lineTo(x_last-i/2,y_last-i);
                //         canvas.moveTo(this.end.x,this.end.y);
                //     }
                //  }
                 else{
                    canvas.moveTo(this.start.x,this.start.y);
                     canvas.lineTo(x_last,y_last);
                     canvas.moveTo(this.end.x,this.end.y);
                 }
                
                
                canvas.stroke();
                
                //双向箭头，画正向箭头
                canvas.save();
               
                canvas.translate(this.end.x,this.end.y);
                
                var ang=(this.end.x-this.start.x)/(this.end.y-this.start.y);
                ang=Math.atan(ang);
                if(this.end.y-this.start.y >= 0){
                    canvas.rotate(-ang);
                }else{
                    canvas.rotate(Math.PI-ang);//加个180度，反过来
                }
                canvas.lineTo(-this.arrowWidth/1.732,-this.arrowWidth);
                if(this.arrow == "singleSolid"){
                    canvas.lineTo(0,-this.arrowWidth); //实箭头
                }else{
                    canvas.lineTo(0,-this.arrowWidth/2);//箭头
                }
                canvas.lineTo(this.arrowWidth/1.732,-this.arrowWidth);
                canvas.lineTo(0,0);
                canvas.fill();
                canvas.restore();
                canvas.closePath();
            }else{
                //双箭头。线绘制的起点需要缩短两个线宽的的长度。计算绘制的起点的点坐标
                var x_start,y_start;
                y_start = this.start.y+(this.borderWidth*2*(this.end.y-this.start.y)/this.line_len);
                x_start = this.start.x+(this.borderWidth*2*(this.end.x-this.start.x)/this.line_len);
                var i=parseFloat(this.borderWidth)-2;
                if(parseFloat(this.borderWidth)>=3 && parseFloat(this.height)==0){
                canvas.moveTo(x_start-i,y_start);
                canvas.lineTo(x_last+i,y_last);
                }else if(parseFloat(this.borderWidth)>=3 && parseFloat(this.width)==0){
                    
                    canvas.moveTo(x_start,y_start-i);
                    canvas.lineTo(x_last,y_last+i);
                }
                // else if(parseFloat(this.borderWidth)>=3 && parseFloat(this.width)!==0 && parseFloat(this.height)!==0){
                //     if(parseFloat(this.points[0][1])==parseFloat(this.points[1][0])){
                //         canvas.moveTo(x_start+i,y_start-i/2);
                //         canvas.lineTo(x_last-i,y_last+i/2);
                //     }else if(parseFloat(this.points[0][0])==parseFloat(this.points[1][1])){
                //         canvas.moveTo(x_start-i,y_start+i/2);
                //         canvas.lineTo(x_last+i,y_last-i/2);
                //     }else if(parseFloat(this.points[0][0])==parseFloat(this.points[0][1])){
                //         canvas.moveTo(x_start-i,y_start-i);
                //         canvas.lineTo(x_last+i,y_last+i);
                //    }else if(parseFloat(this.points[1][0])==parseFloat(this.points[1][1])){
                //         canvas.moveTo(x_start+i/2,y_start+i);
                //         canvas.lineTo(x_last-i/2,y_last-i);
                //    }
                // }
                else{
                canvas.moveTo(x_start,y_start);
                canvas.lineTo(x_last,y_last);
                }
               
                
                canvas.moveTo(this.end.x,this.end.y);
                canvas.stroke();

                //双向箭头，画正向箭头
                canvas.save();
                canvas.translate(this.end.x,this.end.y);
                var ang=(this.end.x-this.start.x)/(this.end.y-this.start.y);
                ang=Math.atan(ang);
                if(this.end.y-this.start.y >= 0){
                    canvas.rotate(-ang);
                }else{
                    canvas.rotate(Math.PI-ang);//加个180度，反过来
                }
                canvas.lineTo(-this.arrowWidth/1.732,-this.arrowWidth);
                if(this.arrow == "doubleSolid"){
                    
                    canvas.lineTo(0,-this.arrowWidth); //实箭头
                }else{
                    canvas.lineTo(0,-this.arrowWidth/2);//箭头
                }
                canvas.lineTo(this.arrowWidth/1.732,-this.arrowWidth);
                canvas.lineTo(0,0);
                canvas.restore();
                canvas.closePath();

                //双向箭头，画反向箭头
                canvas.save();
                canvas.translate(this.start.x,this.start.y);
                var ang=(this.start.x-this.end.x)/(this.start.y-this.end.y);
                ang=Math.atan(ang);
                if(this.start.y-this.end.y >= 0){
                    canvas.rotate(-ang);
                }else{
                    canvas.rotate(Math.PI-ang);
                }
                canvas.moveTo(0,0);
                
                canvas.lineTo(this.arrowWidth/1.732,-this.arrowWidth);
                if(this.arrow == "doubleSolid"){
                    canvas.lineTo(0,-this.arrowWidth); //实箭头
                }else{
                    canvas.lineTo(0,-this.arrowWidth/2);//箭头
                }
                
                canvas.lineTo(-this.arrowWidth/1.732,-this.arrowWidth);
                canvas.fill();
                canvas.restore();
                canvas.closePath();
            }
        }
        this.executePosAnimation(canvas);
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvLineObj.js